import { Component, OnInit, ViewChild, TemplateRef, Output, OnDestroy, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ResourcesService } from '@shared/services/resources.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { BaseService, ErrorService, UsersService } from '@shared/services';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { first, takeUntil } from 'rxjs/operators';
import { SignsService } from '@shared/services/signs.service';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { MatHeaderRow, MatHeaderRowDef, MatTable, MatTableDataSource } from '@angular/material/table';

export type ExportFormat = 'excel' | 'pdf';
@Component({
  selector: 'app-new-sign',
  templateUrl: './new-sign.component.html',
  styleUrls: ['./new-sign.component.scss']
})
export class NewSignComponent implements OnInit, OnDestroy {
    // subscription: Subscription = new Subscription();
    private _unsubscribeAll$ = new Subject<boolean>();

    items: MenuItem[];
    loading = true;

    ngOnDestroy() {
        this._unsubscribeAll$.next(true);
        this._unsubscribeAll$.complete();
        // this.subscription.unsubscribe();
        if (this.modalRef) {
            this.modalRef.hide();
        }
    }
    constructor(
        private translate: TranslateService,
        public router: Router,
        public route: ActivatedRoute,
        private modalService: BsModalService,
        private _signservice: SignsService,
        private fb: FormBuilder,
        private _errorService: ErrorService,
        private _baseService: BaseService,
    ) {}

    searchValue = '';
    changeNewContant = false;
    laddaSearchProgress: boolean | number = false;

    @Input('masterFile')
    masterFile = true;
    SignList = [];
    @Input('icon')
    icon = 'search';
    @ViewChild('formAddEditModal', { static: true }) formModal: TemplateRef<any>;
    modalRef: BsModalRef | null;
    Gridcongid = { grid: 'signTbl', windowRoute: 'signs' };


    @ViewChild(MatSort, { static: true }) sort: MatSort;
    displayedColumns: string[] = ['select', 'signCode', 'singeName', 'ipAddress', 'isValid', ];
    dataSource = new MatTableDataSource([]);
    selection = new SelectionModel(true, []);
    currentSigns = [];
    currentSign;

    @Output('selectedsign')
    selectedsign: EventEmitter<any> = new EventEmitter<any>();
    SignForm: FormGroup;
    saveContant = false;
    SignId = '1';
    formType = 'add';
    selectedStatus = 'Active';
    statusList = [{ name: 'All' }, { name: 'Active' }, { name: 'Inactive' }];
    actionStatus = null;
    actionsList = [{ name: 'Action' }, { name: 'Activate' }, { name: 'Delete' }, { name: 'Inactivate' }];
    newSign = false;
     statusList2 = [
        {
            label: 'Active',
            value: true
        },
        {
            label: 'InActive',
            value: false
        }
    ];

    changeContant() {
        this.selectedsign.emit(this.selection.selected);
    }

    deleteSelected() {
        if (this.selection.selected.length == 0) {
            this.newMessage(60, 'error');
        } else {
            this.currentSigns = this.selection.selected;
            this.newMessage(9, 'delete');
        }
    }
    selectAction() {
        if (this.actionStatus === 'Activate') {
            this.changeStatus('A');
        }
        if (this.actionStatus === 'Delete') {
            this.delete();
        }
        if (this.actionStatus === 'Inactivate') {
            this.changeStatus('NA');
        }
        this.actionStatus = null;
    }
    setCheckboxValue(event, atrr) {
        this.changeNewContant = true;
        if (event) {
            this.SignForm.get(atrr).setValue(true);
        }
    }
    applyfilterStatus() {
        if (this.selectedStatus === 'Active') {
            this.filterStatus(true);
        }
        if (this.selectedStatus === 'Inactive') {
            this.filterStatus(false);
        }
        if (this.selectedStatus === 'All') {
            this.filterStatus('');
        }
    }
    EditSign(row) {
        this.formType = 'edit';
        this.initForm();
        this.getAllTypes();
        this.getById(row.signId);
        this.openModal();
    }
    AddNewItem() {
        this.formType = 'add';
        this.initForm();
        this.openModal();
    }

    openModal() {
        const configs = {
            keyboard: false,
            ignoreBackdropClick: true,
           class: ' modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
            animated: false
        };
        this.modalRef = this.modalService.show(this.formModal, configs);
    }
    closeAddEditModal() {
        if (!this.changeNewContant) {
            this.newSign = false;
            this.modalRef.hide();
        } else this.newMessage(144, 'ClosePopup');
    }
    ClosePopup() {
        this.newSign = false;
        this.CheckResource = false;
        this.modalRef.hide();
        this.changeNewContant = false;
    }
    filterStatus(status) {
        const newList = [];
        this.dataSource = new MatTableDataSource(this.SignList);

        if (status === '') {
        } else {
            this.dataSource.filteredData.forEach((element) => {
                if (element.isvalid === status) {
                    newList.push(element);
                }
            });
            this.dataSource = new MatTableDataSource(newList);
        }
        this.dataSource.sort = this.sort;

        this.applyFilter(this.searchValue);
    }

    SignTypesList=[];
    Selectedsigntype;
    getAllTypes(){
        this._signservice
            .getsigntypes()
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe(
                (result) => {
                    this.SignTypesList=result.data;
                },
                (error) => {}
            );
    }


    getById(SignId) {
        this._signservice
            .getSignById(SignId)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe(
                (result) => {
                    this.currentSign = result.data;
                    //debugger
                    if(result.data.signType == null)
                    this.Selectedsigntype = this.SignTypesList[0];
                    else
                    this.Selectedsigntype = result.data.signType;
                    const controls = this.SignForm.controls;
                    Object.keys(controls).forEach((key) => {
                        if (this.currentSign[key] != null) {
                            this.SignForm.get(key).setValue(this.currentSign[key]);
                        }
                        this.changeNewContant = false;
                    });
                },
                (error) => {}
            );
    }

    ngOnInit() {
        this.items = [
            // {label: 'Update', icon: 'pi pi-refresh', command: () => {
            //     this.update();
            // }},
            // {label: this.translate.instant('Delete'), icon: 'pi pi-times', command: () => {
            //     this.RemoveSelected();
            // }},
            // {label: 'Angular.io', icon: 'pi pi-info', url: 'http://angular.io'},
            // {separator:true},
            // {label: 'Setup', icon: 'pi pi-cog', routerLink: ['/setup']}
        ];

        this.getList();
        this.initForm();
        this.SignForm.valueChanges.pipe(takeUntil(this._unsubscribeAll$)).subscribe((changes) => {
            this.changeNewContant = true;
        });
        this._errorService.currentAction
            .pipe(takeUntil(this._unsubscribeAll$))
            .subscribe((action) => this.actionMsg(action));
    }
    actionMsg(data) {
        if (data !== '') {
            this[data]();
            this._errorService.action('');
        }
    }
    newMessage(id, action) {
        this._errorService.changeMessage({ id: id, action: action });
    }
    getList() {
        this.searchValue = '';
        this._signservice
            .getAllSigns()
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                this.SignList = result.data;
                this.dataSource = new MatTableDataSource(this.SignList);
                this.dataSource.sort = this.sort;
                this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
                if (typeof data[sortHeaderId] === 'string') {
                  return data[sortHeaderId].toLowerCase();
                }
                return data[sortHeaderId];
              };
                this.loading = false;
                //  this.applyfilterStatus();
                // Filter predicate for signs component
this.dataSource.filterPredicate = function (data, filterObjectString: string): boolean {
    const filterObj: FilterSignObject = JSON.parse(filterObjectString);
    
    // Extract filter values with null checking and lowercase conversion
    const signeName = filterObj.singeName ? filterObj.singeName.toLowerCase() : null;
    const signCode = filterObj.signCode ? filterObj.signCode.toLowerCase() : null;
    const ipAddress = filterObj.ipAddress ? filterObj.ipAddress.toLowerCase() : null;
    const status = filterObj.active;
    const searchValue = filterObj.searchValue ? filterObj.searchValue.trim().toLowerCase() : '';
    
    // Create searchable string from all data properties
    const dataStr = Object.keys(data)
        .reduce((currentTerm: string, key: string) => {
            return currentTerm + (data[key] || '') + '◬';
        }, '')
        .toLowerCase();
    
    // Apply all filter conditions
    return (
        (data.singeName?.toLowerCase().indexOf(signeName) !== -1 || signeName == null) &&
        (data.signCode?.toLowerCase().indexOf(signCode) !== -1 || signCode == null) &&
        (data.ipAddress?.toLowerCase().indexOf(ipAddress) !== -1 || ipAddress == null) &&
        (data.isValid === status || status === null) &&
        (dataStr.indexOf(searchValue) !== -1 || searchValue === '')
    );
};
            });
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    checkboxLabel(row): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.email + 1}`;
    }

    applyFilter(filterValue: string) {
        //this.dataSource.filter = filterValue.trim().toLowerCase();
      this.filterObj.searchValue = filterValue || '';
        
        // Apply the updated filter object
        this.applyAdvancedFilter();
      }
 
    private initForm(): void {
        this.SignForm = this.fb.group({
            signId: new FormControl(null),
            singeName: new FormControl(null, [Validators.required]),
            signCode: new FormControl(null, [Validators.required]),
            ipAddress: new FormControl(null),
            resourceName: new FormControl(null),
            SignType: new FormControl(null),
            parentResource: new FormControl(null),
            signStatus: new FormControl(null),
            isValid: new FormControl(true)
        });
    }
    setTumbnail(data) {
        this.SignForm.get('photo').setValue(data);
    }
    setFileName(data) {
        this.SignForm.get('photo').setValue(data);
    }

    saveAddEditSign() {
        this.laddaSearchProgress = 1;
        const controls = this.SignForm.controls;
        Object.keys(controls).forEach((key) => {
            controls[key].markAsTouched();
        });

        if (this.SignForm.status === 'VALID') {
            this.saveContant = false;
            if (this.SignForm.value.signId == null) {
                this._signservice
                    .addSign(this.SignForm.value)
                    .pipe(takeUntil(this._unsubscribeAll$), first())
                    .subscribe(
                        (result) => {
                            if (result.isSuccess) {
                                // const dgwData = result.data;
                                this.newMessage(93, '');
                            } else {
                                this.newMessage(77, '');
                            }
                            this.getList();
                        },
                        (error) => {
                            this.laddaSearchProgress = false;
                        }
                    );
            } else {
                if (!this.CheckResource) {
                    this._signservice
                        .editSign(this.SignForm.value)
                        .pipe(takeUntil(this._unsubscribeAll$), first())
                        .subscribe(
                            (result) => {
                                if (result.isSuccess) {
                                    // const dgwData = result.data;
                                    this.newMessage(4, '');
                                    this.changeNewContant = false;
                                    this.closeAddEditModal();
                                } else if (result.errorCode == 134) {
                                    this.newMessage(134, '');
                                } else {
                                    this.newMessage(77, '');
                                    this.closeAddEditModal();
                                }
                                this.getList();
                                this.laddaSearchProgress = false;
                                this.changeNewContant = false;
                                this.saveContant = false;
                            },
                            (error) => {
                                this.laddaSearchProgress = false;
                            }
                        );
                } else {
                    this.newMessage(151, '');
                }
            }
        } else {
            this.saveContant = true;
            window.scrollTo(0, 0);
            this.laddaSearchProgress = false;
            this.newMessage(3, '');
        }
        // this.modalRef.hide();
    }
    CheckResource = false;
    CheckSignResource() {
        this._signservice
            .CheckSignResource(this.SignForm.value)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe(
                (result) => {
                    if (result) {
                        this.CheckResource = false;
                        //this.SignForm.get('resourceName').invalid
                    } else {
                        this.CheckResource = true;
                        // this.SignForm.get('resourceName').valid
                    }
                },
                (error) => {
                    this.laddaSearchProgress = false;
                }
            );
    }

 delete() {
    let idsToDelete: string[] = [];

    if (this.currentSigns && this.currentSigns.length > 0) {
        // Bulk delete
        idsToDelete = this.currentSigns.map((obj) => obj.signId);
    } else if (this.currentSign && this.currentSign.signId) {
        // Single delete
        idsToDelete = [this.currentSign.signId];
    }

    if (idsToDelete.length === 0) return;

    this._signservice
        .deleteSigns(idsToDelete)
        .pipe(takeUntil(this._unsubscribeAll$), first())
        .subscribe(
            (result) => {
                if (result.isSuccess) {
                    this.newMessage(54, '');
                } else {
                    this.newMessage(55, '');
                }
                this.selection = new SelectionModel(true, []);
                this.getList();
                this.laddaSearchProgress = false;
                this.changeNewContant = false;
                this.saveContant = false;
            },
            (error) => {
                this.laddaSearchProgress = false;
            }
        );
}

    changeStatus(data) {}

    getSelectedResources(resources) {
        this.changeNewContant = true;
        this.SignForm.get('parentResource').setValue(resources.resourceId);
        this.SignForm.get('resourceName').setValue(resources.resourceName);
        this.CheckSignResource();
    }


    // new part 
    @ViewChild('filterModal', { static: true }) filterModal: TemplateRef<any>;

     actionList = [
        { label: 'Delete', disabled: false },
      ];

       selectedAction: string | null = null;
          onActionChange(action: any) {
            switch (action.label) {
              case 'Delete':
                this.deleteSelected();
                break;
              default:
                break;
            }
             this.selectedAction = null;
          }

          

             disableActivate = false;
             disableInactivate = false;

          updateActionAvailability() {
    const selected = this.selection.selected;
  
    if (!selected || selected.length === 0) {
      this.disableActivate = false;
      this.disableInactivate = false;
    } else {
      const allActive = selected.every(item => item.isValid === true);
      const allInactive = selected.every(item => item.isValid === false);
  
      if (allActive) {
        this.disableActivate = true;
        this.disableInactivate = false;
      } else if (allInactive) {
        this.disableActivate = false;
        this.disableInactivate = true;
      } else {
        this.disableActivate = true;
        this.disableInactivate = true;
      }
    }
  
    // Update the action list with new disable statuses
    this.actionList = [
      { label: 'Delete', disabled: false },
    ];
  }


//    Export(): void {
//               const fileName = 'exported-data.xlsx';
//               const dataToExport = this.dataSource.filteredData;
            
//               // Optional: map only selected columns
//               const exportData = dataToExport.map(item => ({
//                 singeName: item.singeName,
//                 signCode: item.signCode,
//                 IPAddress: item.ipAddress,
//                 Status: item.isValid ? 'Active' : 'Inactive'
//               }));
            
//               const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
//               const workbook: XLSX.WorkBook = {
//                 Sheets: { data: worksheet },
//                 SheetNames: ['data']
//               };
            
//               const excelBuffer: any = XLSX.write(workbook, {
//                 bookType: 'xlsx',
//                 type: 'array'
//               });
            
//               const blob: Blob = new Blob([excelBuffer], {
//                 type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
//               });
            
//               FileSaver.saveAs(blob, fileName);
//             }
            
             deleteItem(item : any) {
              this.currentSign = item;
        if (this.currentSign == null) {
            this.newMessage(60, 'error');
        } else {
            this.newMessage(9, 'delete');
        }
    }

    applyAdvancedFilter() {
        //debugger
        this.dataSource.filter = JSON.stringify(this.filterObj);
        if(this.modalRef != null){
            this.closeAddEditModal();
        }
    }

     resetAllFilters(){
        this.filterObj = {
            singeName: null,
            signCode: null,
            ipAddress: null,
            active: null,
            searchValue: ''
        };
       // this.applyAdvancedFilter();
    }

    filterObj: FilterSignObject = {
        singeName: null,
        signCode: null,
        ipAddress: null,
        active: null,
        searchValue: ''
    };

      openfilterModal() {

        const configs = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: ' modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
            animated: false
        };
        this.modalRef = this.modalService.show(this.filterModal, configs);
    }

      openAnyModal(modal){
       
        const configs = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: ' modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
            animated: false
        };
        this.modalRef = this.modalService.show(modal, configs);
    }

             showDialog: boolean = false;
              toggleGridPopup(): void {
            this.showDialog = !this.showDialog;
          }
          
            //  ngAfterViewInit() {
            //       this.getTableConfig();
            //   }
          
           
             @ViewChild('signs', { read: MatTable }) categoriesTable: MatTable<any>;
                  @ViewChild('signsRow') MatRow!: MatHeaderRow;
                getTableConfig() {
                  this._baseService
                      .post(`GridConfig/GetGridCongif`, this.Gridcongid)
                      .pipe(takeUntil(this._unsubscribeAll$), first())
                      .subscribe((result) => {
                          if (result.data != null && result.data.length > 0) {
                              let list = result.data
                              this.MatRow = result.data.map((obj) => obj.col);
                              //console.log(this.MatRow.nativeElement.getAttribute('matHeaderRowDef'))
                              console.log(this.categoriesTable._contentHeaderRowDefs.toArray());
                              this.categoriesTable._contentHeaderRowDefs.toArray()[0].columns = list.map((obj) => obj.col);
                              this.categoriesTable._contentRowDefs.toArray()[0].columns = list.map((obj) => obj.col);
          
                              this.categoriesTable.renderRows();
                          }
                      });
              }
          
              


             updateNewCol(event) {
            if (event) {
              // Always start with the "select" column
              let visibleCols = event.filter((e) => e.isShowen === true && e.col !== 'select');
              let colKeys = ['select', ...visibleCols.map((obj) => obj.col)];
          
              this.MatRow = colKeys;
          
              if (this.categoriesTable?._contentHeaderRowDefs?.length) {
                this.categoriesTable._contentHeaderRowDefs.toArray()[0].columns = colKeys;
              }
          
              if (this.categoriesTable?._contentRowDefs?.length) {
                this.categoriesTable._contentRowDefs.toArray()[0].columns = colKeys;
              }
          
              this.categoriesTable.renderRows();
            }
          }
          
          
   filterList : any[] = ['Display All' , 'Active' , 'Inactive'];
    selectedDisplayAction: string = 'Display All';
  onFilterChange(filterValue: string) {
  if (!filterValue || filterValue === 'Display All') {
    this.selectedDisplayAction = 'Display All';
    this.dataSource.data = [...this.SignList];
  } else if (filterValue === 'Active') {
    this.selectedDisplayAction = 'Active';
    this.dataSource.data = this.SignList.filter(item => item.isValid === true);

  } else if (filterValue === 'Inactive') {
    this.selectedDisplayAction = 'Inactive';
    this.dataSource.data = this.SignList.filter(item => item.isValid === false);
  }

  this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
                if (typeof data[sortHeaderId] === 'string') {
                  return data[sortHeaderId].toLowerCase();
                }
                return data[sortHeaderId];
              };
}

     @ViewChild('exportModal', { static: true }) exportModal: TemplateRef<any>;
          
          async Export(format: ExportFormat = 'excel'): Promise<void> {
                    const dataToExport = this.dataSource.filteredData;
                    
                    // Optional: map only selected columns
                    const exportData = dataToExport.map(item => ({
                        "Sing Name": item.singeName,
                        "Sign Code": item.signCode,
                        "IP Address": item.ipAddress,
                        "Status": item.isValid ? 'Active' : 'Inactive'
                    }));
                  
                    if (format === 'excel') {
                      await this.exportToExcel(exportData);
                    } else if (format === 'pdf') {
                      await this.exportToPDF(exportData);
                    }
                  }
                  
                  private async exportToExcel(data: any[]): Promise<void> {
                    const fileName = 'Signs.xlsx';
                    
                    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
                    const workbook: XLSX.WorkBook = {
                      Sheets: { data: worksheet },
                      SheetNames: ['data']
                    };
                    
                    const excelBuffer: any = XLSX.write(workbook, {
                      bookType: 'xlsx',
                      type: 'array'
                    });
                    
                    const blob: Blob = new Blob([excelBuffer], {
                      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
                    });
                    
                    await this.saveFile(blob, fileName, 'Excel files', {
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
                    });
                  }
                  
                  private async exportToPDF(data: any[]): Promise<void> {
                    const fileName = 'Signs.pdf';
                    
                    // Create PDF document
                    const doc = new jsPDF();
                    
                    // Add title
                    doc.setFontSize(16);
                    doc.text('Signs Exported Data Report', 14, 20);
                    
                    // Add date
                    doc.setFontSize(10);
                    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);
                    
                    // Prepare table data
                    const tableColumns = ["Sing Name", "Sign Code", "IP Address","Status"];
                    const tableRows = data.map(item => [
                      item["Sing Name"],
                      item["Sign Code"],
                      item["IP Address"],
                      item["Status"],
                    ]);
                    
                    // Add table
                    autoTable(doc, {
                      head: [tableColumns],
                      body: tableRows,
                      startY: 40,
                      styles: {
                        fontSize: 9,
                        cellPadding: 3,
                      },
                      headStyles: {
                        fillColor: [63, 81, 181], // Material Blue
                        textColor: 255,
                        fontStyle: 'bold'
                      },
                      alternateRowStyles: {
                        fillColor: [245, 245, 245]
                      },
                      margin: { top: 40 }
                    });
                    
                    // Convert to blob
                    const pdfBlob = doc.output('blob');
                    
                    await this.saveFile(pdfBlob, fileName, 'PDF files', {
                      'application/pdf': ['.pdf']
                    });
                  }
                  
                  private async saveFile(
                    blob: Blob, 
                    fileName: string, 
                    description: string, 
                    accept: Record<string, string[]>
                  ): Promise<void> {
                    // Check if File System Access API is supported
                    if ('showSaveFilePicker' in window) {
                      try {
                        const fileHandle = await (window as any).showSaveFilePicker({
                          suggestedName: fileName,
                          types: [{
                            description: description,
                            accept: accept
                          }]
                        });
                        
                        const writable = await fileHandle.createWritable();
                        await writable.write(blob);
                        await writable.close();
                        this.ClosePopup()
                        //console.log('File saved successfully!');
                      } catch (error) {
                        if (error.name !== 'AbortError') {
                          console.error('Error saving file:', error);
                          // Fallback to FileSaver
                          FileSaver.saveAs(blob, fileName);
                        }
                      }
                    } else {
                      // Fallback for browsers that don't support File System Access API
                      FileSaver.saveAs(blob, fileName);
                    }
                  }
                  
}

interface FilterSignObject {
    singeName?: string | null;
    signCode?: string | null;
    ipAddress?: string | null;
    active?: boolean | null;
    searchValue?: string | null;
}